export const columns = [
  {
    title: "工作包",
    width: 200,
    key: "workPackagesId",
    slots: { customRender: "workPackagesId" },
  },
  {
    title: "说明",
    width: 300,
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "现场拍照",
    width: 150,
    dataIndex: "isPhotograph",
    key: "isPhotograph",
    slots: { customRender: "isPhotograph" },
  },
  {
    title: "添加说明",
    width: 150,
    dataIndex: "isExplain",
    key: "isExplain",
    slots: { customRender: "isExplain" },
  },

  {
    title: "操作",
    dataIndex: "operation",
    width: 180,
    fixed: "right",
    align: "center",
    slots: { customRender: "operation" },
  },
];

export const detailColumns=[
  {
    title: "工作包",
    width: 200,
    key: "workPackagesName",
  },
  {
    title: "说明",
    width: 300,
    dataIndex: "remark",
    key: "remark",
  },
  {
    title: "现场拍照",
    width: 150,
    dataIndex: "isPhotograph",
    key: "isPhotograph",
    slots: { customRender: "isPhotograph" },
  },
  {
    title: "添加说明",
    width: 150,
    dataIndex: "isExplain",
    key: "isExplain",
    slots: { customRender: "isExplain" },
  },

 
];